import React, { useCallback, useRef } from 'react';
import { useTheme } from '../../context/ThemeContext';

const preferences = [
  { value: 'system', label: '系统', ariaLabel: '跟随系统主题' },
  { value: 'light', label: '浅色', ariaLabel: '浅色主题' },
  { value: 'dark', label: '深色', ariaLabel: '深色主题' }
];

const ThemePreferenceControl = () => {
  const { preference, setThemePreference } = useTheme();
  const optionRefs = useRef([]);

  const handleKeyDown = useCallback((event, currentIndex) => {
    const lastIndex = preferences.length - 1;
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = lastIndex;
    } else {
      return;
    }

    event.preventDefault();
    setThemePreference(preferences[nextIndex].value);
    optionRefs.current[nextIndex]?.focus();
  }, [setThemePreference]);

  return (
    <div className="theme-preference-control" role="radiogroup" aria-label="主题偏好">
      {preferences.map(({ value, label, ariaLabel }, index) => (
        <button
          key={value}
          type="button"
          className={preference === value ? 'active' : ''}
          role="radio"
          aria-label={ariaLabel}
          aria-checked={preference === value}
          tabIndex={preference === value ? 0 : -1}
          ref={element => {
            optionRefs.current[index] = element;
          }}
          onClick={() => setThemePreference(value)}
          onKeyDown={event => handleKeyDown(event, index)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default ThemePreferenceControl;
